import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Modal, ModalOptions } from '@indice/ng-components';
import { FilterDropdownPropertyItem } from '../filter-property-dropdown.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mobile-view-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mobile-view-modal.component.html',
  styleUrl: './mobile-view-modal.component.css',
})
export class MobileViewModalComponent {
  public labelName: string = '';
  public dropdownItems: FilterDropdownPropertyItem[] = [];
  public selectedModalItem: FilterDropdownPropertyItem | null = null;

  constructor(public modalRef: Modal, @Inject(ModalOptions) private _options: ModalOptions) {
    this.labelName = _options?.initialState?.['labelName'] as string;
    this.dropdownItems = _options?.initialState?.['dropdownItems'] as FilterDropdownPropertyItem[];
    this.selectedModalItem = _options?.initialState?.['selectedModalItem'] as FilterDropdownPropertyItem | null;
  }

  selectModalItem(item: FilterDropdownPropertyItem) {
    this.selectedModalItem = item;
    this.dropdownItems.map((i) => (i.key == item.key ? (i.checked = true) : (i.checked = false)));

    // Send selected item to parent
    this.close();
  }

  // # Return the updated item states and selected item when the modal closes.
  close = () => this.modalRef.hide({ dropdownItems: this.dropdownItems, selectedModalItem: this.selectedModalItem });
}
